Object.defineProperty(exports, "__esModule", { value: true })

exports.default = __webpack_require__.stylable.create(
  "root",
  "Text4094550947",
  {"root":"Text4094550947--root","TextColor":"color-5","SmallTitleFont":"\"{theme: 'Page-title', size: '24px', lineHeight: '1.33em'}\"","RunningTextFont":"\"{theme: 'Body-M', size: '16px', lineHeight: '1.5em'}\"","ListTextFont":"\"{theme: 'Body-M', size: '16px', lineHeight: '2em'}\"","LargeTitleFont":"\"{theme: 'Heading-M', size: '32px', lineHeight: '1.25em'}\"","MobileSmallTitleFont":"\"{theme: 'Page-title', size: '20px', lineHeight: '1.4em'}\"","MobileRunningTextFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '1.42em'}\"","MobileListTextFont":"\"{theme: 'Body-M', size: '14px', lineHeight: '1.72em'}\"","MobileLargeTitleFont":"\"{theme: 'Heading-M', size: '24px', lineHeight: '1.33em'}\"","MainTextColor":"--overridable","MainTextFont":"--overridable"},
  "",
  1,
  "Text4094550947"
);

